import { render, staticRenderFns } from "./SsoButton.vue?vue&type=template&id=8967103e&scoped=true"
import script from "./SsoButton.vue?vue&type=script&lang=js"
export * from "./SsoButton.vue?vue&type=script&lang=js"
import style0 from "./SsoButton.vue?vue&type=style&index=0&id=8967103e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8967103e",
  null
  
)

export default component.exports